import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';
import './style.css';
import { Breadcrumb } from '../components/Breadcrumb';
import { PageTitle } from '../components/PageTitle';

const PAGETITLE_JP = '企業理念';
const PAGETITLE_EN = 'Philosophy';

const PhilosophyPageContainer = styled.div.attrs({className: 'philosophy-page-container'})`
  background: #F9FAFA;
  min-height: 100vh;
  padding: 0 0 160px;

  @media (max-width: 768px) {
      padding: 0 20px 95px;
`;




const MainPhilosophySection = styled.section.attrs({className: 'philosophy-section'})`
  color: #0F3F8E;
  margin: 90px 116px 80px;
  text-align: center;
  @media (max-width: 768px) {
    margin: 60px 0;
    text-align: left;
  }
`;

const MainPhilosophyTitle = styled.h1.attrs({className: 'philosophy-title is-animated'})`
  font-family: 'A P-OTF Aoto Gothic StdN', 'Noto Sans JP', sans-serif;
  font-weight: 700;
  font-size: 48px;
  line-height: 1;
  letter-spacing: 0.1em;
  margin: 0 auto;
  display: inline-block;

  @media (max-width: 768px) {
    text-align: left;
    font-size: 32px;
    line-height: 1.2;
  }
  // &.is-animated {
  //   clip-path: inset(0);
  // }
`;

const PhilosophyContentSection = styled.section.attrs({className: 'philosophy-content-section'})`
  background: #0F3F8E;
  color: #FFFFFF;
  padding: 200px 0;
  margin-top: min(8%,120px);

  @media (max-width: 768px) {
    padding: 80px 0;
    margin: 32% -20px 0;
    width: calc(100% + 40px);
  }
`;

const PhilosophyGrid = styled.div.attrs({className: 'philosophy-grid'})`
  display: flex;
  flex-direction: column;
  gap: 183px;
  margin-bottom: 120px;

  @media (max-width: 768px) {
    gap: 30px;
    margin-bottom: 80px;
  }
`;

const PhilosophyCard = styled.div.attrs({className: 'philosophy-card'})`
  text-align: center;
  position: relative;

  @media (max-width: 768px) {
    padding: 40px 20px;
  }
`;

const PhilosophyCardTitle = styled.div.attrs({className: 'philosophy-card-title'})`
  margin-bottom: 30px;

  @media (max-width: 768px) {
    margin-bottom: 20px;
  }
`;

const PhilosophyCardEnglish = styled.h3.attrs({className: 'philosophy-card-en'})`
  font-family: 'Avenir Next', 'Noto Sans JP', sans-serif;
  font-weight: 600;
  font-size: 72px;
  line-height: 1.366;
  letter-spacing: 0.05em;
  color: #0F3F8E;
  margin: 0 0 20px 0;
  -webkit-text-stroke: 1px #84A0CD;

  @media (max-width: 768px) {
    line-height: 1.2;
    margin: 0 0 15px 0;
  }
`;

const PhilosophyCardJapanese = styled.h4.attrs({ className: 'philosophy-card-jp' })`
  margin: 0 0 20px 0;
  color: var(--text_white, #fff);
  text-align: center;
  font-family: 'A P-OTF Aoto Gothic StdN';
  font-size: 36px;
  font-style: normal;
  font-weight: 700;
  line-height: 54px; /* 150% */
  letter-spacing: 3.6px;

  @media (max-width: 768px) {
    line-height: 1.5;
    margin: 0 0 15px 0;
  }
`;

const PhilosophyCardDescription = styled.p.attrs({ className: 'philosophy-card-description' })`
  margin: 0;
  color: var(--text_white, #fff);
  text-align: center;
  font-family: 'A P-OTF Aoto Gothic StdN';
  font-size: 36px;
  font-style: normal;
  font-weight: 700;
  line-height: 54px; /* 150% */
  letter-spacing: 3.6px;

  @media (max-width: 768px) {
    line-height: 1.6;
  }
`;

const ValuesSection = styled.div.attrs({className: 'values-section'})`

  @media (max-width: 768px) {
    padding: 40px 20px;
    margin-bottom: 80px;
    border-radius: 15px;
  }
`;

const ValuesGrid = styled.div.attrs({className: 'values-grid'})`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 40px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 60px;
    align-items: center;
  }
`;

const ValueCard = styled.div.attrs({className: 'values-card'})`
  text-align: center;

  @media (max-width: 768px) {
    padding: 0;
    width: 100%;
  }
`;

const ValueIcon = styled.div.attrs({className: 'value-icon'})`
  width: 398px;
  height: 398px;
  border: 1px solid #FFFFFF;
  border-radius: 50%;
  background: #0F3F8E;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;

  @media (max-width: 768px) {
    width: 90vw;
    height: 90vw;
    margin-left: calc(-45vw + 50%);
    margin-right: calc(-45vw + 50%);
  }
`;

const ValueName = styled.div.attrs({className: 'value-name'})`
  font-family: 'A P-OTF Aoto Gothic StdN', 'Noto Sans JP', sans-serif;
  font-weight: 700;
  font-size: 24px;
  line-height: 2.25;
  letter-spacing: 0.1em;
  margin: 0 0 15px 0;

  @media (max-width: 768px) {
    line-height: 1.4;
    margin: 0 0 10px 0;
  }
`;

const ValueEnglish = styled.div.attrs({className: 'value-en'})`
  font-family: 'Gill Sans', 'Noto Sans JP', sans-serif;
  font-weight: 600;
  font-size: 20px;
  line-height: 1.193;
  letter-spacing: 0.05em;
  color: #84A0CD;
  @media (max-width: 768px) {
    line-height: 1.2;
    margin: 0 0 10px 0;
  }
`;

const ValueDescription = styled.div.attrs({className: 'value-desription'})`
  font-family: 'Noto Sans JP', sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 1.75;
  margin: 0;
  width: 90%;

  @media (max-width: 768px) {
    line-height: 1.5;
    width: 95%;
  }
`;

const MessageSection = styled.section.attrs({className: 'message-section'})`
  padding-top:160px;

  @media (max-width: 768px) {
    padding-top: 47%;
  }
`;

const MessageContent = styled.div.attrs({className: 'message-content'})`
  display: flex;
  gap: 120px;
  align-items: start;
  margin: 120px auto 0;
  max-width: var(--contents-maxwidth-pc);

  @media (max-width: 768px) {
    margin: 18% 0 0;
    flex-direction: column-reverse;
    gap: 40px;
  }
  @media (min-width: 769px) {
    width:95%;
  }
`;

const MessageText = styled.div.attrs({className: 'message-text'})`
  font-family: 'Noto Sans JP', sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 1.75;
  color: #333333;

  p {
    margin: 0;
  }

  p:last-child {
    margin-bottom: 0;
  }

  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 1.6;

    p {
      margin: 0 0 15px 0;
    }
  }
`;

const MessageHighlight = styled.h3.attrs({className: 'message-highlight'})`
  font-family: 'Noto Sans JP', sans-serif;
  font-weight: 500;
  font-size: 36px;
  line-height: 1.5;
  letter-spacing: 0.05em;
  color: #333333;
  margin: 0 0 80px 0;

  @media (max-width: 768px) {
    font-size: 28px;
    line-height: 1.4;
    margin: 0 0 20px 0;
  }
`;

const CEOSection = styled.div.attrs({className: 'ceo-section'})`
  @media (max-width: 768px) {
    order: -1;
    width: 100%;
  }
`;

const CEOImage = styled.img.attrs({className: 'ceo-image'})`
  width: 400px;
  height: 461px;
  border-radius: 20px;
  margin: 0 0 20px 0;
  object-fit: cover;
  display: block;

  @media (max-width: 768px) {
    width: 100%;
    height: auto;
    border-radius: 15px;
  }
`;

const CEOName = styled.p.attrs({className: 'ceo-name'})`
  font-family: 'Noto Sans JP', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 1.75;
  letter-spacing: 0.05em;
  color: #333333;
  margin: 0;
  white-space: pre-line;

  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 1.5;
  }
`;

const PhilosophyStatementSection = styled.section.attrs({className: 'philosophy-statement-section'})`
  margin: 0 160px;
  @media (max-width: 768px) {
    margin: 0;
  }
  @media (min-width: 769px) {
    text-align: center;
  }
`;

const PhilosophyStatement = styled.div.attrs({className: 'philosophy-statement'})`
  margin: 0 auto;
  font-family: 'Noto Sans JP', sans-serif;
  font-weight: 700;
  font-size: 16px;
  letter-spacing: 0.05em;
  color: #333333;

  p {
    margin: 0 0 30px 0;
  }

  p:last-child {
    margin-bottom: 0;
  }

  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 2;

    p {
      margin: 0 0 20px 0;
    }
  }
`;

const scroll = keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(-50%); }
`;

const HeroImageList = styled.div.attrs({className: 'hero-image-list'})`
  animation: ${scroll} 40s linear infinite;
  display: inline-flex;
  justify-content: center;
  height: 300px;
  margin-top: min(6.3%,96px);

  @media (max-width: 768px) {
    height: unset;
    margin-top: 16%;
    padding: 0;
    /* Mobile-specific improvements */
    & > * {
      margin-bottom: 0;
    }
    & > *:last-child {
      margin-bottom: 0;
    }
  }
`;

const HeroImageSection = styled.div.attrs({className: 'hero-image-section'})`
  overflow: hidden;
  width: 100%;
`;

const HeroImageItem = styled.picture.attrs({className: 'hero-image-item'})`
  img {
    display: block;
    width: 518.76px;
    height: 300px;
    border-radius: 20px;

    @media (max-width: 768px) {
    width:auto;
      height: 200px;
      border-radius: 25px;
    }
  }
`;

const HeroImangeWrapper = styled.div`padding-right:20px; @media (max-width: 768px) {padding-right: 15px;}`;



const svgAnimation = (id: string) => {
	const paths = document.querySelectorAll<SVGPathElement>(`#${id} .draw-path`) ;

  let customSettings = [{ delay: 0,   duration: 2 }];

  if (id === 'mission') {
  // mission
	customSettings = [
		{ delay: 0,   duration: 2 },
		{ delay: 0,   duration: 2 },
		{ delay: 0,   duration: 1.2 },
		{ delay: 0,   duration: 1.2 },
		{ delay: 0,   duration: 2 },
		{ delay: 0,   duration: 2 },
		{ delay: 0,   duration: 2 },
	];
  } else if (id === 'vision') {
  // vision
  customSettings = [
		{ delay: 0,   duration: 1.3 },
		{ delay: 0,   duration: 2 },
		{ delay: 0,   duration: 2 },
		{ delay: 0,   duration: 2 },
		{ delay: 0,   duration: 2 },
		{ delay: 0,   duration: 1.4 },
	];
} else if (id === 'values') {
  // values
  customSettings = [
		{ delay: 0,   duration: 2 },
		{ delay: 0,   duration: 2 },
		{ delay: 0,   duration: 1.2 },
		{ delay: 0,   duration: 1.2 },
		{ delay: 0,   duration: 2 },
		{ delay: 0,   duration: 2 },
	];
}

	paths.forEach((path, index) => {
		const length = path.getTotalLength();
		const { delay, duration } = customSettings[index] || { delay: 0, duration: 2 };

		path.style.strokeDasharray = String(length);
		path.style.strokeDashoffset = String(length);

    path.style.animation = `${path.style.animation || ''} draw ${duration}s linear forwards`;

		setTimeout(() => {
			// path.style.animation = `draw ${duration}s linear forwards`;
      path.style.animation = `${path.style.animation || ''} draw ${duration}s linear forwards`;
		}, delay * 1000);
	});
};

const PhilosophyPage: React.FC = () => {
  
  const [isAnimated, setIsAnimated] = useState(false);

  useEffect(() => {

    window.scrollTo(0, 0);

    const timer = setTimeout(() => {
      setIsAnimated(true);
    }, 100);

    let observers: { [key: string]: IntersectionObserver } = {};
    let mo: MutationObserver | null = null;
    const animatedElements = new Set<string>(); // Track which elements have been animated

    const initObserver = (el: Element, id: string) => {
      if (observers[id]) return;
      
      observers[id] = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !animatedElements.has(id)) {
              animatedElements.add(id);
              svgAnimation(id); // Run animation for specific element
              
              observers[id]?.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.3 }
      );
      observers[id].observe(el);
    };

    const setupObservers = () => {
      const elementIds = ["mission", "vision", "values"];
      
      elementIds.forEach(id => {
        const element = document.getElementById(id);
        if (element) {
          initObserver(element, id);
        }
      });
    
    // Check if we still need to watch for missing elements
      const missingElements = elementIds.filter(id => !document.getElementById(id));
      
      if (missingElements.length > 0) {
        // Watch the DOM for missing elements
        mo = new MutationObserver((mutations, observer) => {
          missingElements.forEach(id => {
            const el = document.getElementById(id);
            if (el) {
              initObserver(el, id);
              // Remove from missing elements array
              const index = missingElements.indexOf(id);
              if (index > -1) {
                missingElements.splice(index, 1);
              }
            }
          });
          
          // Disconnect observer when all elements are found
          if (missingElements.length === 0) {
            observer.disconnect();
          }
        });
        mo.observe(document.body, { childList: true, subtree: true });
      }
    };

    setupObservers();

    return () => {
      clearTimeout(timer);
      // Disconnect all intersection observers
      Object.values(observers).forEach(observer => observer?.disconnect());
      // Disconnect mutation observer
      mo?.disconnect();
    }
  }, []);

  return (
    <PhilosophyPageContainer>
      {/* Breadcrumb Navigation */}
      <Breadcrumb 
        items={[
          { label: PAGETITLE_JP } // 現在のページ
        ]} 
      />

      {/* Page Title Section */}
      <PageTitle title={ PAGETITLE_JP } subtitle={ PAGETITLE_EN } />

      {/* Main Philosophy Statement */}
      <MainPhilosophySection>
        <MainPhilosophyTitle>
          ITにふれるすべて<br className="sp-only" />の人々に、<br className="sp-only" />うれしいを。
        </MainPhilosophyTitle>
      </MainPhilosophySection>

      {/* Philosophy Statement */}
      <PhilosophyStatementSection>
        <PhilosophyStatement>
          <p>
            私たちは、ITを単なるツールではなく、人々に喜びをもたらす不可欠な存在と捉えています。
          </p>
          <p>
            現代社会においてITは生活やビジネスに深く浸透していますが、その複雑さゆえに「難しい」と感じる場面も少なくありません。
          </p>
          <p>
            リブゲートの理念は、ITに触れるすべての人々が常に"うれしい" を得られることです。
          </p>
          <p>
            私たちは、この "うれしい" を追求し、ITの可能性を最大限に引き出すことで、社会の発展に貢献し、より多くの人々に喜びを届けられるように常に挑戦し続けます。
          </p>
        </PhilosophyStatement>
      </PhilosophyStatementSection>



        {/* Bottom: Image List with 3 images */}
        <HeroImageSection>
          <HeroImageList>
            <HeroImangeWrapper>
              <HeroImageItem>
                <source 
                    media="(min-width: 769px)" 
                    srcSet="/assets/images/top/hero-image-1.jpg" 
                  />
                <img src="/assets/images/top/hero-image-sp-1.jpg" alt="Hero Image 1" />
              </HeroImageItem>
            </HeroImangeWrapper>
            <HeroImangeWrapper>
            <HeroImageItem>
              <source 
                  media="(min-width: 769px)" 
                  srcSet="/assets/images/top/hero-image-2.jpg" 
                />
                <img src="/assets/images/top/hero-image-sp-2.jpg" alt="Hero Image 2" />
              </HeroImageItem>
            </HeroImangeWrapper>
            <HeroImangeWrapper>
              <HeroImageItem>
                <source 
                    media="(min-width: 769px)" 
                    srcSet="/assets/images/top/hero-image-3.jpg" 
                  />
                <img src="/assets/images/top/hero-image-sp-3.jpg" alt="Hero Image 3" />
              </HeroImageItem>
            </HeroImangeWrapper>
            <HeroImangeWrapper>
            <HeroImageItem>
                <source 
                    media="(min-width: 769px)" 
                    srcSet="/assets/images/top/hero-image-4.jpg" 
                  />
                <img src="/assets/images/top/hero-image-sp-4.jpg" alt="Hero Image 4" />
              </HeroImageItem>
            </HeroImangeWrapper>
            <HeroImangeWrapper>
            <HeroImageItem>
                <source 
                    media="(min-width: 769px)" 
                    srcSet="/assets/images/top/hero-image-5.jpg" 
                  />
                <img src="/assets/images/top/hero-image-sp-5.jpg" alt="Hero Image 5" />
              </HeroImageItem>
            </HeroImangeWrapper>
            <HeroImangeWrapper>
            <HeroImageItem>
                <source 
                    media="(min-width: 769px)" 
                    srcSet="/assets/images/top/hero-image-6.jpg" 
                  />
                <img src="/assets/images/top/hero-image-sp-6.jpg" alt="Hero Image 6" />
              </HeroImageItem>
            </HeroImangeWrapper>
            {/* Repeat */}
            <HeroImangeWrapper>
              <HeroImageItem>
                <source 
                    media="(min-width: 769px)" 
                    srcSet="/assets/images/top/hero-image-1.jpg" 
                  />
                <img src="/assets/images/top/hero-image-sp-1.jpg" alt="Hero Image 1" />
              </HeroImageItem>
            </HeroImangeWrapper>
            <HeroImangeWrapper>
            <HeroImageItem>
              <source 
                  media="(min-width: 769px)" 
                  srcSet="/assets/images/top/hero-image-2.jpg" 
                />
                <img src="/assets/images/top/hero-image-sp-2.jpg" alt="Hero Image 2" />
              </HeroImageItem>
            </HeroImangeWrapper>
            <HeroImangeWrapper>
              <HeroImageItem>
                <source 
                    media="(min-width: 769px)" 
                    srcSet="/assets/images/top/hero-image-3.jpg" 
                  />
                <img src="/assets/images/top/hero-image-sp-3.jpg" alt="Hero Image 3" />
              </HeroImageItem>
            </HeroImangeWrapper>
            <HeroImangeWrapper>
            <HeroImageItem>
                <source 
                    media="(min-width: 769px)" 
                    srcSet="/assets/images/top/hero-image-4.jpg" 
                  />
                <img src="/assets/images/top/hero-image-sp-4.jpg" alt="Hero Image 4" />
              </HeroImageItem>
            </HeroImangeWrapper>
            <HeroImangeWrapper>
            <HeroImageItem>
                <source 
                    media="(min-width: 769px)" 
                    srcSet="/assets/images/top/hero-image-5.jpg" 
                  />
                <img src="/assets/images/top/hero-image-sp-5.jpg" alt="Hero Image 5" />
              </HeroImageItem>
            </HeroImangeWrapper>
            <HeroImangeWrapper>
            <HeroImageItem>
                <source 
                    media="(min-width: 769px)" 
                    srcSet="/assets/images/top/hero-image-6.jpg" 
                  />
                <img src="/assets/images/top/hero-image-sp-6.jpg" alt="Hero Image 6" />
              </HeroImageItem>
            </HeroImangeWrapper>
          </HeroImageList>
        </HeroImageSection>
        


      {/* Philosophy Content */}
      <PhilosophyContentSection>
        {/* Mission, Vision, Values Grid */}
        <PhilosophyGrid>
          <PhilosophyCard>
            <PhilosophyCardTitle>
              <PhilosophyCardEnglish>
                <svg id="mission" width="277" height="98" viewBox="0 0 267 53" fill="none"  stroke="none" xmlns="http://www.w3.org/2000/svg">
                  <path className="draw-path" d="M234.477 17.4401H242.685V22.9841H242.829C243.597 21.2561 244.917 19.7441 246.789 18.4481C248.709 17.1041 250.965 16.4321 253.557 16.4321C255.813 16.4321 257.733 16.8401 259.317 17.6561C260.949 18.4241 262.269 19.4561 263.277 20.7521C264.333 22.0481 265.101 23.5361 265.581 25.2161C266.061 26.8961 266.301 28.6241 266.301 30.4001V52.0001H257.661V32.8481C257.661 31.8401 257.589 30.7841 257.445 29.6801C257.301 28.5761 256.989 27.5921 256.509 26.7281C256.029 25.8161 255.357 25.0721 254.493 24.4961C253.677 23.9201 252.573 23.6321 251.181 23.6321C249.789 23.6321 248.589 23.9201 247.581 24.4961C246.573 25.0241 245.733 25.7201 245.061 26.5841C244.437 27.4481 243.957 28.4561 243.621 29.6081C243.285 30.7121 243.117 31.8401 243.117 32.9921V52.0001H234.477V17.4401Z" />
                  <path className="draw-path" d="M184.922 34.5761C184.922 31.8401 185.402 29.3681 186.362 27.1601C187.37 24.9041 188.714 22.9841 190.394 21.4001C192.074 19.8161 194.066 18.5921 196.37 17.7281C198.674 16.8641 201.122 16.4321 203.714 16.4321C206.306 16.4321 208.754 16.8641 211.058 17.7281C213.362 18.5921 215.354 19.8161 217.034 21.4001C218.714 22.9841 220.034 24.9041 220.994 27.1601C222.002 29.3681 222.506 31.8401 222.506 34.5761C222.506 37.3121 222.002 39.8081 220.994 42.0641C220.034 44.3201 218.714 46.2641 217.034 47.8961C215.354 49.4801 213.362 50.7281 211.058 51.6401C208.754 52.5521 206.306 53.0081 203.714 53.0081C201.122 53.0081 198.674 52.5521 196.37 51.6401C194.066 50.7281 192.074 49.4801 190.394 47.8961C188.714 46.2641 187.37 44.3201 186.362 42.0641C185.402 39.8081 184.922 37.3121 184.922 34.5761ZM193.706 34.5761C193.706 35.9201 193.898 37.2641 194.282 38.6081C194.714 39.9521 195.338 41.1521 196.154 42.2081C196.97 43.2641 198.002 44.1281 199.25 44.8001C200.498 45.4721 201.986 45.8081 203.714 45.8081C205.442 45.8081 206.93 45.4721 208.178 44.8001C209.426 44.1281 210.458 43.2641 211.274 42.2081C212.09 41.1521 212.69 39.9521 213.074 38.6081C213.506 37.2641 213.722 35.9201 213.722 34.5761C213.722 33.2321 213.506 31.9121 213.074 30.6161C212.69 29.2721 212.09 28.0721 211.274 27.0161C210.458 25.9601 209.426 25.1201 208.178 24.4961C206.93 23.8241 205.442 23.4881 203.714 23.4881C201.986 23.4881 200.498 23.8241 199.25 24.4961C198.002 25.1201 196.97 25.9601 196.154 27.0161C195.338 28.0721 194.714 29.2721 194.282 30.6161C193.898 31.9121 193.706 33.2321 193.706 34.5761Z" />
                  <path className="draw-path" d="M164.216 17.44H172.856V52H164.216V17.44ZM162.992 5.70402C162.992 4.31202 163.496 3.11202 164.504 2.10402C165.56 1.04802 166.88 0.52002 168.464 0.52002C170.048 0.52002 171.368 1.02402 172.424 2.03202C173.528 2.99202 174.08 4.21602 174.08 5.70402C174.08 7.19202 173.528 8.44002 172.424 9.44802C171.368 10.408 170.048 10.888 168.464 10.888C166.88 10.888 165.56 10.384 164.504 9.37602C163.496 8.32002 162.992 7.09602 162.992 5.70402Z" />
                  <path className="draw-path" d="M147.415 26.6561C146.647 25.6481 145.591 24.7841 144.247 24.0641C142.903 23.2961 141.439 22.9121 139.855 22.9121C138.463 22.9121 137.191 23.2001 136.039 23.7761C134.887 24.3521 134.311 25.3121 134.311 26.6561C134.311 28.0001 134.935 28.9601 136.183 29.5361C137.479 30.0641 139.351 30.6161 141.799 31.1921C143.095 31.4801 144.391 31.8641 145.687 32.3441C147.031 32.8241 148.231 33.4721 149.287 34.2881C150.391 35.0561 151.279 36.0401 151.951 37.2401C152.623 38.3921 152.959 39.8081 152.959 41.4881C152.959 43.6001 152.551 45.4001 151.735 46.8881C150.967 48.3281 149.911 49.5041 148.567 50.4161C147.271 51.3281 145.735 51.9761 143.959 52.3601C142.231 52.7921 140.431 53.0081 138.559 53.0081C135.871 53.0081 133.255 52.5281 130.711 51.5681C128.167 50.5601 126.055 49.1441 124.375 47.3201L130.063 41.9921C131.023 43.2401 132.271 44.2721 133.807 45.0881C135.343 45.9041 137.047 46.3121 138.919 46.3121C139.543 46.3121 140.167 46.2401 140.791 46.0961C141.463 45.9521 142.063 45.7361 142.591 45.4481C143.167 45.1121 143.623 44.6801 143.959 44.1521C144.295 43.6241 144.463 42.9761 144.463 42.2081C144.463 40.7681 143.791 39.7361 142.447 39.1121C141.151 38.4881 139.183 37.8641 136.543 37.2401C135.247 36.9521 133.975 36.5921 132.727 36.1601C131.527 35.6801 130.447 35.0801 129.487 34.3601C128.527 33.5921 127.759 32.6561 127.183 31.5521C126.607 30.4481 126.319 29.0801 126.319 27.4481C126.319 25.5281 126.703 23.8721 127.471 22.4801C128.287 21.0881 129.343 19.9601 130.639 19.0961C131.935 18.1841 133.399 17.5121 135.031 17.0801C136.663 16.6481 138.343 16.4321 140.071 16.4321C142.567 16.4321 144.991 16.8641 147.343 17.7281C149.743 18.5921 151.639 19.9121 153.031 21.6881L147.415 26.6561Z" />
                  <path className="draw-path" d="M111.821 26.6561C111.053 25.6481 109.997 24.7841 108.653 24.0641C107.309 23.2961 105.845 22.9121 104.261 22.9121C102.869 22.9121 101.597 23.2001 100.445 23.7761C99.2933 24.3521 98.7172 25.3121 98.7172 26.6561C98.7172 28.0001 99.3412 28.9601 100.589 29.5361C101.885 30.0641 103.757 30.6161 106.205 31.1921C107.501 31.4801 108.797 31.8641 110.093 32.3441C111.437 32.8241 112.637 33.4721 113.693 34.2881C114.797 35.0561 115.685 36.0401 116.357 37.2401C117.029 38.3921 117.365 39.8081 117.365 41.4881C117.365 43.6001 116.957 45.4001 116.141 46.8881C115.373 48.3281 114.317 49.5041 112.973 50.4161C111.677 51.3281 110.141 51.9761 108.365 52.3601C106.637 52.7921 104.837 53.0081 102.965 53.0081C100.277 53.0081 97.6612 52.5281 95.1172 51.5681C92.5732 50.5601 90.4613 49.1441 88.7812 47.3201L94.4692 41.9921C95.4292 43.2401 96.6772 44.2721 98.2132 45.0881C99.7492 45.9041 101.453 46.3121 103.325 46.3121C103.949 46.3121 104.573 46.2401 105.197 46.0961C105.869 45.9521 106.469 45.7361 106.997 45.4481C107.573 45.1121 108.029 44.6801 108.365 44.1521C108.701 43.6241 108.869 42.9761 108.869 42.2081C108.869 40.7681 108.197 39.7361 106.853 39.1121C105.557 38.4881 103.589 37.8641 100.949 37.2401C99.6532 36.9521 98.3812 36.5921 97.1332 36.1601C95.9332 35.6801 94.8532 35.0801 93.8932 34.3601C92.9332 33.5921 92.1652 32.6561 91.5892 31.5521C91.0132 30.4481 90.7253 29.0801 90.7253 27.4481C90.7253 25.5281 91.1093 23.8721 91.8773 22.4801C92.6933 21.0881 93.7492 19.9601 95.0452 19.0961C96.3413 18.1841 97.8052 17.5121 99.4372 17.0801C101.069 16.6481 102.749 16.4321 104.477 16.4321C106.973 16.4321 109.397 16.8641 111.749 17.7281C114.149 18.5921 116.045 19.9121 117.437 21.6881L111.821 26.6561Z" />
                  <path className="draw-path" d="M70.1615 17.44H78.8015V52H70.1615V17.44ZM68.9375 5.70402C68.9375 4.31202 69.4415 3.11202 70.4495 2.10402C71.5055 1.04802 72.8255 0.52002 74.4095 0.52002C75.9935 0.52002 77.3135 1.02402 78.3695 2.03202C79.4735 2.99202 80.0255 4.21602 80.0255 5.70402C80.0255 7.19202 79.4735 8.44002 78.3695 9.44802C77.3135 10.408 75.9935 10.888 74.4095 10.888C72.8255 10.888 71.5055 10.384 70.4495 9.37602C69.4415 8.32002 68.9375 7.09602 68.9375 5.70402Z"/>
                  <path className="draw-path" d="M0.617188 1.02393H14.8012L28.0492 37.2399H28.2652L41.3692 1.02393H55.6252V51.9999H46.6252V11.0319H46.4812L31.0012 51.9999H24.6652L9.40119 11.0319H9.25719V51.9999H0.617188V1.02393Z" />
                </svg>
              </PhilosophyCardEnglish>
              <PhilosophyCardJapanese>ミッション</PhilosophyCardJapanese>
            </PhilosophyCardTitle>
            <PhilosophyCardDescription id="mission-animation">
              <picture>
                <source
                  srcSet="/assets/images/philosophy/mission-txt1-pc.svg"
                  media="(min-width: 769px)" />
                <img src="/assets/images/philosophy/mission-txt1.svg" alt="最先端テクノロジーで、人々の課題を解決し、喜びと可能性を広げる" />
              </picture>
            </PhilosophyCardDescription>
          </PhilosophyCard>

          <PhilosophyCard>
            <PhilosophyCardTitle>
              <PhilosophyCardEnglish>
                <svg id="vision" width="221" height="98" viewBox="0 0 217 53" fill="none"  stroke="none" xmlns="http://www.w3.org/2000/svg">
                  <path className="draw-path" d="M184.43 17.4401H192.638V22.9841H192.782C193.55 21.2561 194.87 19.7441 196.742 18.4481C198.662 17.1041 200.918 16.4321 203.51 16.4321C205.766 16.4321 207.686 16.8401 209.27 17.6561C210.902 18.4241 212.222 19.4561 213.23 20.7521C214.286 22.0481 215.054 23.5361 215.534 25.2161C216.014 26.8961 216.254 28.6241 216.254 30.4001V52.0001H207.614V32.8481C207.614 31.8401 207.542 30.7841 207.398 29.6801C207.254 28.5761 206.942 27.5921 206.462 26.7281C205.982 25.8161 205.31 25.0721 204.446 24.4961C203.63 23.9201 202.526 23.6321 201.134 23.6321C199.742 23.6321 198.542 23.9201 197.534 24.4961C196.526 25.0241 195.686 25.7201 195.014 26.5841C194.39 27.4481 193.91 28.4561 193.574 29.6081C193.238 30.7121 193.07 31.8401 193.07 32.9921V52.0001H184.43V17.4401Z" />
                  <path className="draw-path" d="M134.867 34.5761C134.867 31.8401 135.347 29.3681 136.307 27.1601C137.315 24.9041 138.659 22.9841 140.339 21.4001C142.019 19.8161 144.011 18.5921 146.315 17.7281C148.619 16.8641 151.067 16.4321 153.659 16.4321C156.251 16.4321 158.699 16.8641 161.003 17.7281C163.307 18.5921 165.299 19.8161 166.979 21.4001C168.659 22.9841 169.979 24.9041 170.939 27.1601C171.947 29.3681 172.451 31.8401 172.451 34.5761C172.451 37.3121 171.947 39.8081 170.939 42.0641C169.979 44.3201 168.659 46.2641 166.979 47.8961C165.299 49.4801 163.307 50.7281 161.003 51.6401C158.699 52.5521 156.251 53.0081 153.659 53.0081C151.067 53.0081 148.619 52.5521 146.315 51.6401C144.011 50.7281 142.019 49.4801 140.339 47.8961C138.659 46.2641 137.315 44.3201 136.307 42.0641C135.347 39.8081 134.867 37.3121 134.867 34.5761ZM143.651 34.5761C143.651 35.9201 143.843 37.2641 144.227 38.6081C144.659 39.9521 145.283 41.1521 146.099 42.2081C146.915 43.2641 147.947 44.1281 149.195 44.8001C150.443 45.4721 151.931 45.8081 153.659 45.8081C155.387 45.8081 156.875 45.4721 158.123 44.8001C159.371 44.1281 160.403 43.2641 161.219 42.2081C162.035 41.1521 162.635 39.9521 163.019 38.6081C163.451 37.2641 163.667 35.9201 163.667 34.5761C163.667 33.2321 163.451 31.9121 163.019 30.6161C162.635 29.2721 162.035 28.0721 161.219 27.0161C160.403 25.9601 159.371 25.1201 158.123 24.4961C156.875 23.8241 155.387 23.4881 153.659 23.4881C151.931 23.4881 150.443 23.8241 149.195 24.4961C147.947 25.1201 146.915 25.9601 146.099 27.0161C145.283 28.0721 144.659 29.2721 144.227 30.6161C143.843 31.9121 143.651 33.2321 143.651 34.5761Z" />
                  <path className="draw-path" d="M114.161 17.44H122.801V52H114.161V17.44ZM112.938 5.70402C112.938 4.31202 113.441 3.11202 114.449 2.10402C115.505 1.04802 116.825 0.52002 118.409 0.52002C119.993 0.52002 121.313 1.02402 122.369 2.03202C123.473 2.99202 124.025 4.21602 124.025 5.70402C124.025 7.19202 123.473 8.44002 122.369 9.44802C121.313 10.408 119.993 10.888 118.409 10.888C116.825 10.888 115.505 10.384 114.449 9.37602C113.441 8.32002 112.938 7.09602 112.938 5.70402Z" />
                  <path className="draw-path" d="M97.3603 26.6561C96.5923 25.6481 95.5363 24.7841 94.1923 24.0641C92.8483 23.2961 91.3843 22.9121 89.8003 22.9121C88.4083 22.9121 87.1363 23.2001 85.9843 23.7761C84.8323 24.3521 84.2563 25.3121 84.2563 26.6561C84.2563 28.0001 84.8803 28.9601 86.1283 29.5361C87.4243 30.0641 89.2963 30.6161 91.7443 31.1921C93.0403 31.4801 94.3363 31.8641 95.6323 32.3441C96.9763 32.8241 98.1763 33.4721 99.2323 34.2881C100.336 35.0561 101.224 36.0401 101.896 37.2401C102.568 38.3921 102.904 39.8081 102.904 41.4881C102.904 43.6001 102.496 45.4001 101.68 46.8881C100.912 48.3281 99.8563 49.5041 98.5123 50.4161C97.2163 51.3281 95.6803 51.9761 93.9043 52.3601C92.1763 52.7921 90.3763 53.0081 88.5043 53.0081C85.8163 53.0081 83.2003 52.5281 80.6563 51.5681C78.1123 50.5601 76.0003 49.1441 74.3203 47.3201L80.0083 41.9921C80.9683 43.2401 82.2163 44.2721 83.7523 45.0881C85.2883 45.9041 86.9923 46.3121 88.8643 46.3121C89.4883 46.3121 90.1123 46.2401 90.7363 46.0961C91.4083 45.9521 92.0083 45.7361 92.5363 45.4481C93.1123 45.1121 93.5683 44.6801 93.9043 44.1521C94.2403 43.6241 94.4083 42.9761 94.4083 42.2081C94.4083 40.7681 93.7363 39.7361 92.3923 39.1121C91.0963 38.4881 89.1283 37.8641 86.4883 37.2401C85.1923 36.9521 83.9203 36.5921 82.6723 36.1601C81.4723 35.6801 80.3923 35.0801 79.4323 34.3601C78.4723 33.5921 77.7043 32.6561 77.1283 31.5521C76.5523 30.4481 76.2643 29.0801 76.2643 27.4481C76.2643 25.5281 76.6483 23.8721 77.4163 22.4801C78.2323 21.0881 79.2883 19.9601 80.5843 19.0961C81.8803 18.1841 83.3443 17.5121 84.9763 17.0801C86.6083 16.6481 88.2883 16.4321 90.0163 16.4321C92.5123 16.4321 94.9363 16.8641 97.2883 17.7281C99.6883 18.5921 101.584 19.9121 102.976 21.6881L97.3603 26.6561Z" />
                  <path className="draw-path" d="M55.7006 17.44H64.3406V52H55.7006V17.44ZM54.4766 5.70402C54.4766 4.31202 54.9806 3.11202 55.9886 2.10402C57.0446 1.04802 58.3646 0.52002 59.9486 0.52002C61.5326 0.52002 62.8526 1.02402 63.9086 2.03202C65.0126 2.99202 65.5646 4.21602 65.5646 5.70402C65.5646 7.19202 65.0126 8.44002 63.9086 9.44802C62.8526 10.408 61.5326 10.888 59.9486 10.888C58.3646 10.888 57.0446 10.384 55.9886 9.37602C54.9806 8.32002 54.4766 7.09602 54.4766 5.70402Z"/>
                  <path className="draw-path" d="M0.28125 1.02393H10.4333L24.4732 40.2639H24.7612L38.9453 1.02393H48.7373L28.2892 51.9999H20.4412L0.28125 1.02393Z" />
                </svg>
              </PhilosophyCardEnglish>
              <PhilosophyCardJapanese>ビジョン</PhilosophyCardJapanese>
            </PhilosophyCardTitle>
            <PhilosophyCardDescription>
            <picture>
                <source
                  srcSet="/assets/images/philosophy/mission-txt2-pc.svg"
                  media="(min-width: 769px)" />
                <img src="/assets/images/philosophy/mission-txt2.svg" alt="常に挑戦し、変化を恐れず、技術で未来を切り拓く" />
              </picture>
              
            </PhilosophyCardDescription>
          </PhilosophyCard>
        </PhilosophyGrid>

        {/* Values Section */}
        <ValuesSection>
          <PhilosophyCard>
            <PhilosophyCardTitle>
              <PhilosophyCardEnglish>
                <svg id="values" width="237" height="98" viewBox="0 0 235 56" fill="none"  stroke="#84A0CD" xmlns="http://www.w3.org/2000/svg">
                  <path className="draw-path" d="M229.235 29.6561C228.467 28.6481 227.411 27.7841 226.067 27.0641C224.723 26.2961 223.259 25.9121 221.675 25.9121C220.283 25.9121 219.011 26.2001 217.859 26.7761C216.707 27.3521 216.131 28.3121 216.131 29.6561C216.131 31.0001 216.755 31.9601 218.003 32.5361C219.299 33.0641 221.171 33.6161 223.619 34.1921C224.915 34.4801 226.211 34.8641 227.507 35.3441C228.851 35.8241 230.051 36.4721 231.107 37.2881C232.211 38.0561 233.099 39.0401 233.771 40.2401C234.443 41.3921 234.779 42.8081 234.779 44.4881C234.779 46.6001 234.371 48.4001 233.555 49.8881C232.787 51.3281 231.731 52.5041 230.387 53.4161C229.091 54.3281 227.555 54.9761 225.779 55.3601C224.051 55.7921 222.251 56.0081 220.379 56.0081C217.691 56.0081 215.075 55.5281 212.531 54.5681C209.987 53.5601 207.875 52.1441 206.195 50.3201L211.883 44.9921C212.843 46.2401 214.091 47.2721 215.627 48.0881C217.163 48.9041 218.867 49.3121 220.739 49.3121C221.363 49.3121 221.987 49.2401 222.611 49.0961C223.283 48.9521 223.883 48.7361 224.411 48.4481C224.987 48.1121 225.443 47.6801 225.779 47.1521C226.115 46.6241 226.283 45.9761 226.283 45.2081C226.283 43.7681 225.611 42.7361 224.267 42.1121C222.971 41.4881 221.003 40.8641 218.363 40.2401C217.067 39.9521 215.795 39.5921 214.547 39.1601C213.347 38.6801 212.267 38.0801 211.307 37.3601C210.347 36.5921 209.579 35.6561 209.003 34.5521C208.427 33.4481 208.139 32.0801 208.139 30.4481C208.139 28.5281 208.523 26.8721 209.291 25.4801C210.107 24.0881 211.163 22.9601 212.459 22.0961C213.755 21.1841 215.219 20.5121 216.851 20.0801C218.483 19.6481 220.163 19.4321 221.891 19.4321C224.387 19.4321 226.811 19.8641 229.163 20.7281C231.563 21.5921 233.459 22.9121 234.851 24.6881L229.235 29.6561Z" />
                  <path className="draw-path" d="M189.696 34.2641C189.696 33.1601 189.528 32.1041 189.192 31.0961C188.904 30.0881 188.424 29.2001 187.752 28.4321C187.08 27.6641 186.216 27.0641 185.16 26.6321C184.152 26.1521 182.952 25.9121 181.56 25.9121C178.968 25.9121 176.76 26.7041 174.936 28.2881C173.16 29.8241 172.176 31.8161 171.984 34.2641H189.696ZM198.336 38.1521C198.336 38.5361 198.336 38.9201 198.336 39.3041C198.336 39.6881 198.312 40.0721 198.264 40.4561H171.984C172.08 41.7041 172.392 42.8561 172.92 43.9121C173.496 44.9201 174.24 45.8081 175.152 46.5761C176.064 47.2961 177.096 47.8721 178.248 48.3041C179.4 48.7361 180.6 48.9521 181.848 48.9521C184.008 48.9521 185.832 48.5681 187.32 47.8001C188.808 46.9841 190.032 45.8801 190.992 44.4881L196.752 49.0961C193.344 53.7041 188.4 56.0081 181.92 56.0081C179.232 56.0081 176.76 55.6001 174.504 54.7841C172.248 53.9201 170.28 52.7201 168.6 51.1841C166.968 49.6481 165.672 47.7761 164.712 45.5681C163.8 43.3121 163.344 40.7681 163.344 37.9361C163.344 35.1521 163.8 32.6321 164.712 30.3761C165.672 28.0721 166.968 26.1281 168.6 24.5441C170.232 22.9121 172.152 21.6641 174.36 20.8001C176.616 19.8881 179.04 19.4321 181.632 19.4321C184.032 19.4321 186.24 19.8401 188.256 20.6561C190.32 21.4241 192.096 22.6001 193.584 24.1841C195.072 25.7201 196.224 27.6641 197.04 30.0161C197.904 32.3201 198.336 35.0321 198.336 38.1521Z" />
                  <path className="draw-path" d="M151.386 54.9999H143.179V49.4559H143.034C142.266 51.1839 140.922 52.7199 139.002 54.0639C137.13 55.3599 134.898 56.0079 132.306 56.0079C130.05 56.0079 128.106 55.6239 126.474 54.8559C124.89 54.0399 123.57 52.9839 122.514 51.6879C121.506 50.3919 120.762 48.9039 120.282 47.2239C119.802 45.5439 119.562 43.8159 119.562 42.0399V20.4399H128.202V39.5919C128.202 40.5999 128.274 41.6559 128.418 42.7599C128.562 43.8639 128.874 44.8719 129.354 45.7839C129.835 46.6479 130.483 47.3679 131.299 47.9439C132.163 48.5199 133.291 48.8079 134.683 48.8079C136.027 48.8079 137.203 48.5439 138.211 48.0159C139.267 47.4399 140.106 46.7199 140.73 45.8559C141.402 44.9919 141.907 44.0079 142.243 42.9039C142.579 41.7519 142.746 40.5999 142.746 39.4479V20.4399H151.386V54.9999Z" />
                  <path className="draw-path" d="M97.1328 0.567871H105.773V54.9999H97.1328V0.567871Z" />
                  <path className="draw-path" d="M75.2556 50.6081H75.0396C74.1756 52.1441 72.7836 53.4161 70.8636 54.4241C68.9436 55.3841 66.7596 55.8641 64.3116 55.8641C62.9196 55.8641 61.4556 55.6721 59.9196 55.2881C58.4316 54.9521 57.0396 54.3761 55.7436 53.5601C54.4956 52.6961 53.4396 51.5921 52.5756 50.2481C51.7596 48.8561 51.3516 47.1521 51.3516 45.1361C51.3516 42.5441 52.0716 40.4801 53.5116 38.9441C54.9996 37.4081 56.8956 36.2321 59.1996 35.4161C61.5036 34.6001 64.0476 34.0721 66.8316 33.8321C69.6636 33.5441 72.4236 33.4001 75.1116 33.4001V32.5361C75.1116 30.3761 74.3196 28.7921 72.7356 27.7841C71.1996 26.7281 69.3516 26.2001 67.1916 26.2001C65.3676 26.2001 63.6156 26.5841 61.9356 27.3521C60.2556 28.1201 58.8636 29.0561 57.7596 30.1601L53.2956 24.9041C55.2636 23.0801 57.5196 21.7121 60.0636 20.8001C62.6556 19.8881 65.2716 19.4321 67.9116 19.4321C70.9836 19.4321 73.5036 19.8641 75.4716 20.7281C77.4876 21.5921 79.0716 22.7201 80.2236 24.1121C81.3756 25.5041 82.1676 27.0641 82.5996 28.7921C83.0796 30.5201 83.3196 32.2481 83.3196 33.9761V55.0001H75.2556V50.6081ZM75.1116 39.2321H73.1676C71.7756 39.2321 70.3116 39.3041 68.7756 39.4481C67.2396 39.5441 65.8236 39.8081 64.5276 40.2401C63.2316 40.6241 62.1516 41.2001 61.2876 41.9681C60.4236 42.6881 59.9916 43.6961 59.9916 44.9921C59.9916 45.8081 60.1596 46.5041 60.4956 47.0801C60.8796 47.6081 61.3596 48.0401 61.9356 48.3761C62.5116 48.7121 63.1596 48.9521 63.8796 49.0961C64.5996 49.2401 65.3196 49.3121 66.0396 49.3121C69.0156 49.3121 71.2716 48.5201 72.8076 46.9361C74.3436 45.3521 75.1116 43.1921 75.1116 40.4561V39.2321Z" />
                  <path className="draw-path" d="M0.28125 4.02393H10.4333L24.4732 43.2639H24.7612L38.9453 4.02393H48.7373L28.2892 54.9999H20.4412L0.28125 4.02393Z" />
                </svg>
              </PhilosophyCardEnglish>
              <PhilosophyCardJapanese>バリュー</PhilosophyCardJapanese>
            </PhilosophyCardTitle>
          </PhilosophyCard>
          
          <ValuesGrid>
            <ValueCard>
              <ValueIcon>
                <ValueEnglish>Honesty</ValueEnglish>
                <ValueName>誠実に向き合う</ValueName>
                <ValueDescription>
                自分の都合を優先せず、相手にとって何が正しいのか考えて行動する
                相手をリスペクトし、感謝を素直に行う
                </ValueDescription>
              </ValueIcon>
            </ValueCard>

            <ValueCard>
              <ValueIcon>
                <ValueEnglish>Best</ValueEnglish>
                <ValueName>最善を尽くす</ValueName>
                <ValueDescription>
                  与えられた条件の中で最善の結果を出す
                  期待以上の成果を目指し、そのために努力し、技術や能力を磨く
                </ValueDescription>
              </ValueIcon>
            </ValueCard>

            <ValueCard>
              <ValueIcon>
                <ValueEnglish>Internalizing</ValueEnglish>
                <ValueName>じぶんごと化して考える</ValueName>
                <ValueDescription>
                相手の課題を自分事として捉える
                指示を待つだけではなく、意図を理解した上で意思をもって行動する
                </ValueDescription>
              </ValueIcon>
            </ValueCard>
          </ValuesGrid>
        </ValuesSection>
      </PhilosophyContentSection>

      {/* Company Message Section */}
      <MessageSection>
        {/* Page Title Section */}
      <PageTitle title="メッセージ" subtitle="Message" />
        
        <MessageContent>
          <div>
            <MessageHighlight>
              クライアントの真のポテンシャルを実現するプロフェッショナル集団として
            </MessageHighlight>
            <MessageText>
              <p>
                リブゲートは2010年に設立して以来、あらゆる産業のクライアントの皆さまに対して最先端かつ安定したテクノロジーを駆使したITサービスを提供してきた、総合システムインテグレータです。
              </p>
              <p>
                私たちの強みは、幅広いテクノロジーの知見と深いビジネスへの理解を兼ね備えたプロフェッショナルチームにあります。クライアント企業の経営課題を正確に把握し、それに対する最適な解決策を設計、開発、実装するために、長い期間にわたって高いコミットメントで寄り添い、プロジェクトの進行にあたっては透明性とコミュニケーションを重視し、クライアントの皆さまとの緊密な協力関係を築くことに注力しています。
              </p>
              <p>
                私たちは、クライアント企業のデジタルトランスフォーメーションを加速する信頼されるパートナーとして、クライアント企業がその真のポテンシャルを発揮し、持続可能な成長を実現される支援ができることを目指しております。AI/機械学習、データサイエンスといった先端技術を柔軟に活用していただきながら、オペレーションや業務プロセスの自動化・効率化、顧客体験の刷新・進化、データドリブンな意思決定などの支援を実現しています。
              </p>
              <p>
                私たちと共に、未来への第一歩を踏み出しましょう。
              </p>
            </MessageText>
          </div>
          
          <CEOSection>
            <CEOImage src="/assets/images/philosophy/ceo.jpg" alt="代表取締役社長 佐藤 和良" />
            <CEOName>
              代表取締役社長{'\n'}佐藤 和良
            </CEOName>
          </CEOSection>
        </MessageContent>
      </MessageSection>
    </PhilosophyPageContainer>
  );
};

export default PhilosophyPage;
